import { NONE_OPTION_ID } from "components/NewAdvancedSearch/filters/noneOption";
import MetaLeadsEventService from "services/MetaLeadsEvent";

// The None sentinel matches the registrants that have no CRM lead. The list is
// short, so the search runs on the loaded options.
const fetchStatusOptions = async ({ search_query = "" } = {}) => {
  const events = await MetaLeadsEventService.list();
  const term = search_query.trim().toLowerCase();
  return [
    { id: NONE_OPTION_ID, name: "No Meta status" },
    ...events.map(event => ({ id: event.id, name: event.name })),
  ].filter(option => option.name.toLowerCase().includes(term));
};

export const REGISTRANT_LEAD_STATUS_FILTER = {
  key: "meta_status_id",
  title: "Meta Status",
  type: "select",
  queryFn: fetchStatusOptions,
};
